import React from 'react';
import {Routes, Route, Outlet} from 'react-router-dom';
import {ProtectedLayout} from '../components/ProtectedLayout';
import Login from '../modules/Auth/Login';
import LoginBackoffice from '../modules/Auth/LoginBackoffice';
import {ProtectedBackoffice} from '../components/ProtectedBackoffice';
 
import UsersList from '../modules/Users/screens/UsersList';
import ProfessionalList from '../modules/Professional/screens/ProfessionalList';
import CustomersList from '../modules/Customers/screens/CustomersList';
import EquipamentsList from '../modules/Equipaments/screens/EquipamentsList';
import ReportList from '../modules/Reports/screens/ReportList';
import NotFound from '../modules/NotFound';
import Settings from '../modules/Settings/screens';
import PublictList from '../modules/Public/screens/PublictList';
import SpecialtyList from '../modules/Specialties/screens/SpecialtyList';
import Conference from '../modules/Conference';


export default () => {
    return (
        <Routes>
            <Route index path="/" element={<LoginBackoffice />} />
            
            <Route path="*" element={<NotFound />} />
            {/* <Route path="criar-conta" element={<Register />} />
            <Route path="recuperar-senha" element={<LostPass />} />*/}

            <Route path="dashboard" element={<ProtectedBackoffice />}>
                <Route index element={<ReportList />} />
                {/* <Route index path="laudos" element={<ReportList />} /> */}
                <Route path="usuarios" element={<Outlet />}>
                    <Route index element={<UsersList />} />
                </Route>
                <Route path="especialidades" element={<Outlet />}>
                    <Route index element={<SpecialtyList />} />
                </Route>
                <Route path="profissionais" element={<Outlet />}>
                    <Route index element={<ProfessionalList />} />
                </Route>
                <Route path="clientes" element={<Outlet />}>
                    <Route index element={<CustomersList />} />
                </Route>
                
                <Route path="configuracoes" element={<Settings />} />
            </Route>

            <Route path="public/login" element={<Login />} />
            <Route path="conference" element={<Outlet />}>
                <Route index path=':id' element={<Conference />} />
            </Route>


        </Routes>
    );
};
